<template>
  <div class="pay_page page">
    <div class="pay_1" v-if="page == 1">
      <div class="pay_con">
        <span class="title">支付内容</span>
        <span class="text">跨系统账号转移服务</span>
        <span class="text">￥6.00</span>
      </div>
      <div class="pay_choose">
        <span class="title">支付方式</span>
        <div class="tab_box">
          <div
            @click="payType = 1"
            :class="`zfb ${payType == 1 ? 'on' : ''}`"
            v-if="!inWeiXin"
          >
            <i class="zfb_icon"></i><span>支付宝</span>
          </div>
          <div @click="payType = 2" :class="`wx ${payType == 2 ? 'on' : ''}`">
            <i class="wx_icon"></i><span>微信支付</span>
          </div>
        </div>
      </div>
      <div class="pay_price">
        <span>应付：</span>
        <span>￥6.00</span>
      </div>
      <div class="pay_btn" @click="getOrder">立即支付</div>
    </div>
    <div class="pay_2" v-else>
      <span class="title">转移成功</span>
      <span class="text"
        >你可以登录转移后平台客户端确认转移情况，如有问题请联系客服QQ：800825260
      </span>
      <span class="text" v-if="$parent.system == 2"
        >iOS平台请前往App Store下载</span
      >
      <span class="text" v-else
        >安卓平台：<a
          href="https://mz.zlongame.com/m/main.shtml"
          target="_blank"
          rel="noopener noreferrer"
          >官网链接</a
        ></span
      >
      <span class="tip_text">{{ time }}秒后自动跳转回到首页</span>
      <div class="return_btn" @click="refresh">返回首页</div>
    </div>
    <div class="loading" v-if="loading">
      <span>支付中{{ text }}</span>
      <!-- <div class="loading_icon"></div> -->
    </div>
  </div>
</template>

<script>
import { pay } from '../api/index';
export default {
  components: {},
  data() {
    return {
      inWeiXin: false,
      time: 20,
      payType: 1, //支付方式 1支付宝 2微信
      loading: false,
      page: 1,
      text: '.',
      timer: null
    };
  },
  computed: {},
  watch: {
    loading: function () {
      if (this.loading) {
        this.timer = setInterval(() => {
          if (this.text != '...') {
            this.text += '.';
          } else {
            this.text = '.';
          }
        }, 300);
      } else {
        clearInterval(this.timer);
      }
    }
  },
  methods: {
    refresh() {
      // 获取当前页面的 URL
      var currentUrl = window.location.href;
      // 创建一个 URL 对象
      var url = new URL(currentUrl);
      // 移除 URL 的查询参数
      url.search = '';
      // 重定向到新的 URL，从而刷新页面
      window.location.href = url.href;
    },
    getOrder() {
      this.loading = true;
      let Base64 = require('js-base64').Base64;
      let params = {
        service: 'cstorder',
        data: Base64.encode(
          JSON.stringify({
            appKey: '1486458782785',
            uid: this.$parent.userid,
            goodsNum: '1',
            goodsId: 'pd.mz.arf.6',
            openId: this.$parent.openId,
            token: this.$parent.payToken,
            payType: this.payType,
            plaType: this.$parent.system
          })
        )
      };
      pay(params).then((res) => {
        console.log(res);
        if (res.data.code == 0) {
          console.log(res.data.data, '999');
          // location.href = res.data.appLinkUrl;
          if (this.payType == 2) {
            //微信支付
            if (this.$parent.is_weixin()) {
              let wxPayObj = JSON.parse(res.data.data.appLinkUrl);
              let _this = this;
              wx.chooseWXPay({
                timestamp: wxPayObj.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: wxPayObj.nonceStr, // 支付签名随机串，不长于 32 位
                package: wxPayObj._package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                signType: wxPayObj.signType, // 微信支付V3的传入RSA,微信支付V2的传入格式与V2统一下单的签名格式保持一致
                paySign: wxPayObj.paySign, // 支付签名
                success: function (resChild) {
                  // 支付成功后的回调函数
                  _this.checkOrder({
                    appKey: res.data.data.appKey,
                    payType: res.data.data.payType,
                    orderId: res.data.data.orderId,
                    params: res.data.data.params
                  });
                },
                cancel: function (res) {},
                fail: function (res) {}
              });
            } else {
              location.href = res.data.data.appLinkUrl;
            }
          } else {
            //支付宝
            $('.home').html(res.data.data.appLinkUrl);
          }
        } else {
          this.$parent.getTip(`支付异常，请稍后再试--${res.data}`);
        }
      });
    },
    checkOrder(info) {
      let Base64 = require('js-base64').Base64;
      let params = {
        service: 'query',
        data: Base64.encode(
          JSON.stringify({
            appKey: info.appKey,
            payType: info.payType,
            payOrderId: info.orderId,
            params: info.params
          })
        )
      };
      pay(params).then((res) => {
        console.log(res);
        if (res.data.data == 0) {
          //继续查
          this.checkOrder(info);
        } else if (res.data.data == 1) {
          this.loading = false;
          this.page = 2; //支付成功
          setInterval(() => {
            this.time--;
            if (this.time == 0) {
              this.refresh();
            }
          }, 1000);
        } else if (res.data.data == -2) {
          this.loading = false;
          this.$parent.getTip(`支付超时，请稍后再试`);
        } else {
          this.$parent.getTip(`支付异常，请稍后再试--${res.data}`);
        }
      });
    }
  },
  created() {
    if (this.$parent.is_weixin()) {
      this.inWeiXin = true;
      this.payType = 2;
    }
    if (this.$parent.getParams().data) {
      let data = this.$parent.getParams().data;
      let Base64 = require('js-base64').Base64;
      let info = JSON.parse(Base64.decode(data));
      console.log(info.data);
      this.loading = true;
      this.$parent.system = info.data.plaType || 1; //获取订单转移的系统
      this.payType = info.data.payType;
      this.checkOrder(info.data);
    }
  },
  mounted() {}
};
</script>
<style lang='less' scoped>
.pay_1 {
  .layout-flex(@col,@c,@c);
  .pay_con {
    width: 100%;
    height: 2.42rem;
    background: #feffff;
    .layout-flex(@col,@c,normal);
    padding-left: 0.52rem;
    box-sizing: border-box;
    .title {
      font-weight: 500;
      color: #1b1919;
      font-size: 0.32rem;
      margin-bottom: 0.32rem;
    }
    .text {
      color: #656565;
      font-size: 0.32rem;
      line-height: 0.5rem;
    }
  }
  .pay_choose {
    width: 100%;
    height: 2.42rem;
    background: #feffff;
    .layout-flex(@col,@c,normal);
    padding: 0 0.52rem;
    box-sizing: border-box;
    margin: 0.16rem 0;
    .title {
      font-weight: 500;
      color: #1b1919;
      font-size: 0.32rem;
      margin-bottom: 0.32rem;
    }
    .tab_box {
      width: 100%;
      height: 0.8rem;
      box-sizing: border-box;
      .layout-flex(@r,@b,@c);
      .zfb,
      .wx {
        width: 2.87rem;
        height: 0.8rem;
        border: 0.01rem solid #c1c1c1;
        border-radius: 0.03rem;
        .layout-flex(@r,@a,@c);
        .zfb_icon {
          width: 0.49rem;
          height: 0.49rem;
          background: url('../assets/zfb.png');
          background-size: 100% 100%;
        }
        .wx_icon {
          width: 0.48rem;
          height: 0.47rem;
          background: url('../assets/wx.png');
          background-size: 100% 100%;
        }
        span {
          color: #212121;
          font-size: 0.31rem;
        }
      }
      .on {
        background: #deeaff;
        border: 0.01rem solid #3e73fe;
      }
    }
  }
  .pay_price {
    width: 7.5rem;
    height: 1.42rem;
    background: #feffff;
    padding: 0 0.52rem;
    box-sizing: border-box;
    .layout-flex(@r,normal,@c);
    span:nth-child(1) {
      font-weight: 500;
      color: #1b1919;
      font-size: 0.32rem;
    }
    span:nth-child(2) {
      font-weight: bold;
      color: #3e73fe;
      font-size: 0.5rem;
    }
  }
  .pay_btn {
    width: 6.9rem;
    height: 0.9rem;
    background: #3e73fe;
    border-radius: 0.08rem;
    font-weight: bold;
    color: #ffffff;
    font-size: 0.32rem;
    .layout-flex(@r,@c,@c);
    margin-top: 3rem;
  }
}
.pay_2 {
  width: 100%;
  .layout-flex(@col,@c,@c);
  padding: 0 0.52rem;
  box-sizing: border-box;
  .title {
    width: 100%;
    font-weight: 500;
    color: #3e73fe;
    font-size: 0.38rem;
    margin-top: 0.64rem;
    margin-bottom: 0.68rem;
  }
  .text {
    width: 100%;
    color: #656565;
    font-size: 0.28rem;
    line-height: 0.4rem;
  }
  span:nth-child(2) {
    margin-bottom: 0.3rem;
  }
  .tip_text {
    color: #fb6c3e;
    font-size: 0.24rem;
    margin-top: 5rem;
    margin-bottom: 0.5rem;
  }
  .return_btn {
    width: 100%;
    height: 0.9rem;
    background: #3e73fe;
    border-radius: 0.08rem;
    .layout-flex(@r,@c,@c);
    font-weight: bold;
    color: #ffffff;
    font-size: 0.32rem;
  }
}
.loading {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  font-size: 0.5rem;
  // .loading_icon {
  //   width: 40px;
  //   height: 40px;
  //   animation: rotating 1.4s linear infinite;
  //   border: 3px solid rgba(0, 0, 0, 0.2);
  //   border-top-color: #3498db;
  //   border-radius: 50%;
  // }
  // @keyframes rotating {
  //   from {
  //     transform: rotate(0deg);
  //   }
  //   to {
  //     transform: rotate(360deg);
  //   }
  // }
}
</style>